// src/DatabaseAdmin/Table.jsx
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import styles from './Table.module.scss';

const Table = ({ selectedTable, data, selectedRow, setSelectedRow, onEdit, loading, error }) => {
  if (error) return <div className={styles.error_DatabaseAdmin}>{error}</div>;
  if (loading) return <div className={styles.loading_DatabaseAdmin}>Загрузка...</div>;
  if (!data.length) return <div className={styles.noData_DatabaseAdmin}>Нет данных для отображения</div>;

  return (
    <div className={styles.tableContainer_DatabaseAdmin}>
      <table className={styles.table_DatabaseAdmin}>
        <thead>
          <tr>
            <th>ID</th>
            {selectedTable === 'Регионы' ? (
              <>
                <th>Город</th>
                <th>Регион</th>
              </>
            ) : selectedTable === 'Паблики' ? (
              <>
                <th>Название</th>
                <th>ID группы</th>
                <th>ID региона</th>
              </>
            ) : (
              <>
                <th>Название</th>
                {selectedTable === 'Community' && <th>ID группы</th>}
              </>
            )}
            <th>Действия</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <TableRow
              key={row.id}
              row={row}
              selectedTable={selectedTable}
              isSelected={selectedRow === row.id}
              onSelect={() => setSelectedRow(row.id)}
              onEdit={() => onEdit(row)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  selectedTable: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  selectedRow: PropTypes.any,
  setSelectedRow: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

export default Table;